import apiClient, {
  apiClientForOutSourcing,
} from "../../../utils/lib/apiClient";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useSetRecoilState } from "recoil";
export const useDeleteAddressList = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const deleteToAddress = async (workerId: string) => {
    setLoadingAnimation(true);
    setLoadingText("削除中...");
    try {
      const res = await apiClientForOutSourcing.delete(`/address/to-address`, {
        params: {
          workerId: workerId || undefined,
        },
      });

      const data = res.status;
      if (data === 200) return res.data;
      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  const deleteCcAddress = async (workerId: string) => {
    setLoadingAnimation(true);
    setLoadingText("削除中...");
    try {
      const res = await apiClientForOutSourcing.delete(`/address/cc-address`, {
        params: {
          workerId: workerId || undefined,
        },
      });

      const data = res.status;
      if (data === 200) return res.data;
      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  return { deleteToAddress, deleteCcAddress };
};
